import * as Scrivito from "scrivito";

const CookeiOptionsWidget = Scrivito.provideWidgetClass("CookeiOptionsWidget", {
  attributes: {
    youtubeList: "widgetlist",
    vimeoList: "widgetlist",
    facebookList: "widgetlist",
    tiktokList: "widgetlist",
    matomoList: "widgetlist",
    technicalNeededList: "widgetlist",
    openstreetmapList: "widgetlist",
    studiassistList: "widgetlist",
  },
});

export default CookeiOptionsWidget;
